module.exports = __webpack_public_path__ + "img/diagram_9_1.23a85119.png";